import React from 'react';
import { Star, MapPin } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
const testimonials = [{
  quote: 'En dos semanas de aplicar el sistema ya tomaba decisiones más rápido en los partidos. Mi entrenador me preguntó qué había cambiado. Le dije que finalmente tenía un plan claro.',
  name: 'Matías L.',
  role: 'Armador en Club Deportivo',
  location: 'Buenos Aires'
}, {
  quote: 'Llevaba años sintiendo que mi techo estaba puesto. Con el sistema de los 6 tomos entendí que el problema no era mi talento. Era que nunca había trabajado los 5 pilares juntos.',
  name: 'Sebastián R.',
  role: 'Armador en Liga Regional',
  location: 'Rosario'
}, {
  quote: 'El tomo de distribución táctica me cambió completamente la cabeza. Ahora leo la defensa rival antes de tocar el balón. Mis compañeros no lo pueden creer.',
  name: 'Nicolás F.',
  role: 'Armador Competitivo',
  location: 'Córdoba'
}];
export const TestimonialStrip = () => {
  return <section className="py-8 md:py-12 bg-navy-950 border-y border-navy-800" data-id="element-421">
      <div className="container mx-auto px-4" data-id="element-422">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-id="element-423">
          {testimonials.map((t, i) => <FadeIn key={i} delay={i * 0.1} className="bg-navy-900 border border-navy-700 p-5 md:p-6 rounded-xl relative" data-id="element-424">
              <div className="absolute top-0 left-6 -translate-y-1/2 text-4xl text-gold-500 font-serif" data-id="element-425">
                "
              </div>
              <div className="flex gap-1 mb-4" data-id="element-426">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 fill-gold-500 text-gold-500" data-id="element-427" />)}
              </div>
              <p className="text-gray-300 text-sm italic mb-6 leading-relaxed" data-id="element-428">
                {t.quote}
              </p>
              <div className="mt-auto" data-id="element-429">
                <div className="font-bold text-white text-sm" data-id="element-430">{t.name}</div>
                <div className="text-xs text-gray-400 flex items-center gap-1 mt-1" data-id="element-431">
                  {t.role} <span className="text-navy-600" data-id="element-432">•</span>{' '}
                  <MapPin className="w-3 h-3 text-gold-500" data-id="element-433" /> {t.location}
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
};